"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Immutable selection class for selecting ids */
class IdSelection {
    ids;
    inverted;
    // ids is map of ids to true, inverted is boolean
    constructor(ids = {}, inverted = false) {
        this.ids = ids;
        this.inverted = inverted;
    }
    isSelected(id) {
        if (this.ids[id]) {
            return !this.inverted;
        }
        return this.inverted;
    }
    isNone() {
        return Object.keys(this.ids).length === 0 && !this.inverted;
    }
    all() {
        return new IdSelection({}, true);
    }
    none() {
        return new IdSelection({}, false);
    }
    invert() {
        return new IdSelection(this.ids, !this.inverted);
    }
    add(id) {
        if (this.inverted) {
            const newIds = { ...this.ids };
            delete newIds[id];
            return new IdSelection(newIds, true);
        }
        else {
            return new IdSelection({ ...this.ids, [id]: true }, false);
        }
    }
    remove(id) {
        if (!this.inverted) {
            const newIds = { ...this.ids };
            delete newIds[id];
            return new IdSelection(newIds, false);
        }
        else {
            return new IdSelection({ ...this.ids, [id]: true }, true);
        }
    }
    toggle(id) {
        if (this.isSelected(id)) {
            return this.remove(id);
        }
        else {
            return this.add(id);
        }
    }
}
exports.default = IdSelection;
